import axiosInstance from 'Utils/axiosInstance';
import { trackError } from 'Utils/errorMonitoring';
import { IS_PRODUCTION, COMMIT_HASH } from 'config';

export async function getCountries() {
    const response = await axiosInstance.get('/countries');
    return response?.data;
}

export async function getCurrencies() {
    const response = await axiosInstance.get('/currencies');
    return response?.data;
}

export async function getLanguages() {
    // const response = await axiosInstance.get("/languages");

    return [
        { code: 'ES', name: 'Spanish', name_es: 'Castellano' },
        { code: 'EN', name: 'English', name_es: 'Inglés' },
    ];
}

export async function getTimeZones() {
    const response = await axiosInstance.get('/timezones');
    return response?.data;
}

export async function getIsLatestAppVersion() {
    if (!IS_PRODUCTION || !COMMIT_HASH) {
        return true;
    }

    try {
        const response = await axiosInstance.get('/version');
        return response?.data?.version === COMMIT_HASH;
    } catch (error) {
        trackError(error);
        return true;
    }
}
